import tw from 'twin.macro' // eslint-disable-line no-unused-vars
import React from 'react'
import PropTypes from 'prop-types'
import { HTMLContent } from './Content'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const Faq = ({ items }) => (
  <div tw="bg-white">
    <div tw="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-24">
      <div tw="mx-auto max-w-4xl divide-y divide-gray-900/10">
        <h2 tw="text-2xl font-bold leading-10 tracking-tight text-gray-900">Frequently asked questions</h2>
          <dl tw="mt-10 space-y-6 divide-y divide-gray-900/10">
          {items.map((faq) => (
            <Disclosure as="div" key={faq.title} tw="pt-6">
            {({ open }) => (
              <>
                <dt>
                  <DisclosureButton tw="flex w-full items-start justify-between text-left text-gray-900">
                    <span tw="text-base font-semibold leading-7">{faq.title}</span>
                    <span tw="ml-6 flex h-7 items-center">
                      {open ? (
                        <MinusSmallIcon tw="h-6 w-6" aria-hidden="true" />
                      ) : (
                        <PlusSmallIcon tw="h-6 w-6" aria-hidden="true" />
                      )}
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" tw="mt-2 pr-12">
                  <HTMLContent content={faq.text} />
                </DisclosurePanel>
              </>
            )}
            </Disclosure>
          ))}
          </dl>
      </div>
    </div>
  </div>
)

Faq.propTypes = {
  faq: PropTypes.array
}

export default Faq
